import * as React from "react";
import styles from "styled-components";
import { Row as BsRow } from "components/bootstrap";
import DocumentationLink from "components/support/DocumentationLink";
import { Container, Col, Row } from "./FlexBox";
const ContainerWithBackground = styles(Container)`
  background-color: ${({ theme }) => theme.colors.global.contentBackground};
  padding: ${({ theme }) => theme.spacings.md};
  border-radius: ${({ theme }) => theme.spacings.xs};
  justify-content: stretch;
  align-content: stretch;
  overflow: auto;
`;
const Header = styles(Row)`
  margin-bottom: ${({ theme }) => theme.spacings.sm};

  & > h1 {
    width: 100%;
  }
`;
function SectionContainer({
  children,
  variant = "column",
  title = void 0,
  subTitle = void 0,
  rightSection = void 0,
  docLink = void 0
}) {
  return /* @__PURE__ */ React.createElement(BsRow, { style: { padding: 0 } }, /* @__PURE__ */ React.createElement(ContainerWithBackground, { $direction: variant, $width: "100%", className: "content" }, (title || rightSection) && /* @__PURE__ */ React.createElement(Header, { $align: "flex-start", $justify: "space-between" }, title && /* @__PURE__ */ React.createElement("h1", null, /* @__PURE__ */ React.createElement(Col, { $gap: "xs" }, title, subTitle && /* @__PURE__ */ React.createElement("small", { className: "description no-bm" }, subTitle))), (rightSection || docLink) && /* @__PURE__ */ React.createElement(Col, { $gap: "sm", $align: "flex-end" }, docLink ? /* @__PURE__ */ React.createElement(DocumentationLink, { text: docLink.title, page: docLink.path, displayIcon: true }) : null, rightSection)), children));
}
export default SectionContainer;
